import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withKeys as _withKeys, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "lots-card-view" }
const _hoisted_2 = { class: "card-view-header" }
const _hoisted_3 = { class: "customize-controls" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "pro-badge"
}
const _hoisted_7 = { class: "card-header" }
const _hoisted_8 = { class: "lot-number" }
const _hoisted_9 = { class: "lot-status" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "card-content" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["type", "value"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "field-label" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["type", "value"]
const _hoisted_19 = {
  key: 1,
  class: "field-content"
}
const _hoisted_20 = {
  key: 0,
  class: "buyers-display"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "buyer-names" }
const _hoisted_23 = {
  key: 0,
  class: "buyer-name"
}
const _hoisted_24 = {
  key: 1,
  class: "buyer-name"
}
const _hoisted_25 = {
  key: 1,
  class: "buyers-display empty"
}
const _hoisted_26 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["customize-btn", { 'tier2-enabled': $props.canCustomizeColumns }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleCustomizeColumns'))),
          disabled: !$props.canCustomizeColumns
        }, [
          _createElementVNode("img", {
            src: require('@/assets/icons/icon-settings.svg')
          }, null, 8, _hoisted_5),
          _cache[9] || (_cache[9] = _createElementVNode("span", null, "Customise Columns", -1)),
          (!$props.canCustomizeColumns)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, "PRO"))
            : _createCommentVNode("", true)
        ], 10, _hoisted_4)
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.lots, (lot) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "lot-card",
        key: lot._id
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, "Lot " + _toDisplayString(lot.title), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: _normalizeClass(["badge", $setup.props.getLotStatusClass($setup.props.getStatusForClass(lot.status))]),
              onClick: ($event: any) => ($props.openStatusModal(lot))
            }, _toDisplayString($setup.props.displayStatus(lot.status)), 11, _hoisted_10),
            (lot.status === $setup.LotStatus.OFFLINE)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["badge bordered-badge", `bordered-badge-${$setup.props.getLotStatusClass(lot.offlineSale.salePhase)}`])
                }, _toDisplayString($setup.props.getOfflineDisplayStatus(lot.offlineSale.salePhase)), 3))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            class: _normalizeClass(["field-row", { disabled: !$props.isFieldEditable('price') }])
          }, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "field-label" }, "Price", -1)),
            _createElementVNode("div", {
              class: _normalizeClass(["field-value", { disabled: !$props.isFieldEditable('price') }]),
              onClick: ($event: any) => ($props.openEditPriceModal(lot))
            }, [
              _createElementVNode("span", null, _toDisplayString($props.getColumnDisplayValue(lot, "price")), 1)
            ], 10, _hoisted_12)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["field-row", { disabled: !$props.isFieldEditable('size') }])
          }, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "field-label" }, "Size", -1)),
            _createElementVNode("div", {
              class: _normalizeClass(["field-value", { disabled: !$props.isFieldEditable('size') }]),
              onClick: ($event: any) => ($props.startEdit(lot._id, 'size'))
            }, [
              ($props.isEditing(lot._id, 'size'))
                ? (_openBlock(), _createElementBlock("input", {
                    key: 0,
                    type: $props.getFieldType('size'),
                    value: $props.editingValue,
                    onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('updateEditingValue', $event.target.value))),
                    onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('saveEdit'))),
                    onKeyup: [
                      _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.$emit('saveEdit')), ["enter"])),
                      _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.$emit('cancelEdit')), ["escape"]))
                    ]
                  }, null, 40, _hoisted_14))
                : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString($props.getColumnDisplayValue(lot, "size")), 1))
            ], 10, _hoisted_13)
          ], 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.visibleColumns, (column) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["field-row", { disabled: !$props.isFieldEditable(column.key) }]),
              key: column.key
            }, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(column.value), 1),
              _createElementVNode("div", {
                class: _normalizeClass(["field-value", { disabled: !$props.isFieldEditable(column.key) }]),
                onClick: ($event: any) => ($props.startEdit(lot._id, column.key))
              }, [
                ($props.isEditing(lot._id, column.key))
                  ? (_openBlock(), _createElementBlock("input", {
                      key: 0,
                      type: $props.getFieldType(column.key),
                      value: $props.editingValue,
                      onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('updateEditingValue', $event.target.value))),
                      onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('saveEdit'))),
                      onKeyup: [
                        _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.$emit('saveEdit')), ["enter"])),
                        _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.$emit('cancelEdit')), ["escape"]))
                      ]
                    }, null, 40, _hoisted_18))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      (column.key === 'lotBuyers')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            ($props.getColumnDisplayValue(lot, column.key) !== '--')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  _createElementVNode("img", {
                                    class: "buyer-icon",
                                    src: require('@/assets/icons/users-icon.svg')
                                  }, null, 8, _hoisted_21),
                                  _createElementVNode("div", _hoisted_22, [
                                    (lot.lotBuyers?.firstBuyer)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(lot.lotBuyers.firstBuyer), 1))
                                      : _createCommentVNode("", true),
                                    (lot.lotBuyers?.secondBuyer)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(lot.lotBuyers.secondBuyer), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  _createElementVNode("img", {
                                    class: "buyer-icon",
                                    src: require('@/assets/icons/users-icon.svg')
                                  }, null, 8, _hoisted_26),
                                  _cache[12] || (_cache[12] = _createElementVNode("div", { class: "buyer-names" }, "--", -1))
                                ]))
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString($props.getColumnDisplayValue(lot, column.key)), 1)
                          ], 64))
                    ]))
              ], 10, _hoisted_17)
            ], 2))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}